export const CHECKBOX_CELL = 'CHECKBOX_CELL'
export const EXPANDABLE_CELL = 'EXPANDABLE_CELL'
export const DELETE_CELL = 'DELETE_CELL'
export const ROW_HEIGHT = '50px'
export const TOOLTIP_TEXT_BREAKER = 75
